module.exports = __webpack_public_path__ + "static/media/ModulesBlue.fd6a955e.svg";